import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSki = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 451,
	height: 629,
	fill: "none",
	viewBox: "0 0 451 629",
	...props,
	children: [
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 107.17,
			cy: 670.38,
			fill: "#f2f1f1",
			rx: 101.64,
			ry: 51.73
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 287.01,
			cy: 640.42,
			fill: "#f2f1f1",
			rx: 140.74,
			ry: 70.79
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#0a73ba",
			d: "m222.8 639.2 43.1-563.84C270.07 29 298.73 8.57 308.12 5.83c10.48 6.28 6.9 29.6 2.86 66.81l-46.7 575.39z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#1d8ad3",
			d: "m219.02 639.2 43.1-563.85c4.17-46.34 35.7-66.26 45.07-69 10.48 6.28 4.05 29.09 0 66.3l-46.7 575.38z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#191919",
			fillOpacity: .11,
			d: "M240.23 365.28c19.89 72.79 25.3 243.89 21.11 257.75-5.23 17.33-33.66-253.13-21.1-257.75"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#d9d9d9",
			d: "M220.35 651.9 169.7 89.42c-3.54-46.34 6.67-62.43 15.44-66.69 11.33 4.45 26.24 19.24 28.4 56.55l49.03 574.45z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#18a0fb",
			d: "M220.35 651.9 169.7 89.42c-3.54-46.34 6.67-62.43 15.44-66.69 11.33 4.45 26.24 19.24 28.4 56.55l49.03 574.45z"
		}),
		/* @__PURE__ */ _jsxs("mask", {
			id: "mask0_25837_69690",
			width: 95,
			height: 632,
			x: 168,
			y: 22,
			maskUnits: "userSpaceOnUse",
			style: { maskType: "alpha" },
			children: [/* @__PURE__ */ _jsx("path", {
				fill: "#d9d9d9",
				d: "M220.36 651.9 169.7 89.4c-3.55-46.33 6.67-62.43 15.43-66.68 11.33 4.45 26.25 19.23 28.4 56.55l49.03 574.44z"
			}), /* @__PURE__ */ _jsx("path", {
				fill: "#18a0fb",
				d: "M220.36 651.9 169.7 89.4c-3.55-46.33 6.67-62.43 15.43-66.68 11.33 4.45 26.25 19.23 28.4 56.55l49.03 574.44z"
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			mask: "url(#mask0_25837_69690)",
			children: [
				/* @__PURE__ */ _jsx("rect", {
					width: 8.44,
					height: 8.17,
					fill: "#fa4969",
					transform: "matrix(.997 -.082 -.088 -.996 172.93 273.32)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 172.61,
					height: 277.93,
					fill: "#fa4969",
					transform: "matrix(.997 -.081 -.088 -.996 162.68 80.71)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.44,
					height: 8.17,
					fill: "#fa4969",
					transform: "matrix(.997 -.081 -.088 -.996 216.46 80.86)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.44,
					height: 8.17,
					fill: "#fa4969",
					transform: "matrix(.997 -.082 -.088 -.996 231.07 260.36)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.44,
					height: 8.17,
					fill: "#fa4969",
					transform: "matrix(.997 -.082 -.088 -.996 240.2 267.8)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.44,
					height: 8.17,
					fill: "#fa4969",
					transform: "matrix(.997 -.082 -.088 -.996 247.88 258.98)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.44,
					height: 8.17,
					fill: "#fa4969",
					transform: "matrix(.997 -.082 -.088 -.996 257.02 266.44)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.16,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(-94.4 147.55 -14.66)skewX(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.16,
					height: 4.21,
					fill: "#fff",
					transform: "matrix(.077 .997 .997 -.071 175.02 151.68)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.16,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(265.9 151.88 -15.3)skewY(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.16,
					height: 4.21,
					fill: "#fff",
					transform: "matrix(.077 .997 .997 -.071 178.94 147.31)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.16,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(265.9 155.9 -15.51)skewY(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.16,
					height: 4.21,
					fill: "#fff",
					transform: "matrix(.077 .997 .997 -.071 182.8 142.94)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.16,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(265.9 159.9 -15.73)skewY(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.16,
					height: 4.21,
					fill: "#fff",
					transform: "matrix(.077 .997 .997 -.071 186.7 138.58)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.16,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(-94.4 139 -42.15)skewX(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.16,
					height: 4.21,
					fill: "#fff",
					transform: "matrix(.077 .997 .997 -.071 193.25 113.56)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.16,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(-94.4 143.02 -42.36)skewX(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.16,
					height: 4.21,
					fill: "#fff",
					transform: "matrix(.077 .997 .997 -.071 197.15 109.19)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.16,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(-94.4 147.02 -42.57)skewX(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.16,
					height: 4.21,
					fill: "#fff",
					transform: "matrix(.077 .997 .997 -.071 201.03 104.83)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.16,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(-94.4 151.02 -42.77)skewX(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.16,
					height: 4.21,
					fill: "#fff",
					transform: "matrix(.077 .997 .997 -.071 204.92 100.46)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.16,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(85.6 37.6 163.24)skewX(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.16,
					height: 4.21,
					fill: "#fff",
					transform: "matrix(-.077 -.997 -.997 .071 195.91 92.91)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.16,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(85.6 37.36 158.91)skewX(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.16,
					height: 4.21,
					fill: "#fff",
					transform: "matrix(-.077 -.997 -.997 .071 192 97.28)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.16,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(85.6 37.13 154.58)skewX(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.16,
					height: 4.21,
					fill: "#fff",
					transform: "matrix(-.077 -.997 -.997 .071 188.12 101.65)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.16,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(85.9 37.2 149.76)skewY(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.16,
					height: 4.21,
					fill: "#fff",
					transform: "matrix(-.077 -.997 -.997 .071 184.23 106.02)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.16,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(85.6 30.56 193.65)skewX(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.16,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(85.9 41.1 182.02)scale(-1 1)skewY(.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.16,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(85.9 30.73 188.7)skewY(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.16,
					height: 4.21,
					fill: "#fff",
					transform: "matrix(-.077 -.997 -.997 .071 215.82 132.4)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.16,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(85.6 30.1 185)skewX(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.16,
					height: 4.21,
					fill: "#fff",
					transform: "matrix(-.077 -.997 -.997 .071 211.96 136.76)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.16,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(85.9 30.26 180.1)skewY(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.16,
					height: 4.21,
					fill: "#fff",
					transform: "matrix(-.077 -.997 -.997 .071 208.07 141.13)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 4.08,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(-94.4 141.44 -20.35)skewX(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 4.08,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(-94.4 145.44 -20.54)skewX(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 4.08,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(265.9 149.75 -21.2)skewY(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 4.08,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(265.9 153.76 -21.4)skewY(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 4.08,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(-94.4 157.45 -21.17)skewX(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 4.08,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(-94.4 161.45 -21.38)skewX(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 4.08,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(85.6 24.42 200.27)skewX(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 4.08,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(85.6 24.21 195.96)skewX(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 4.08,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(85.6 23.99 191.62)skewX(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 4.08,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(85.6 23.76 187.3)skewX(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 4.08,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(85.6 23.54 183)skewX(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 4.08,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(85.9 23.7 178.1)skewY(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 4.08,
					height: 4.21,
					fill: "#fff",
					transform: "matrix(.077 .997 .997 -.071 175.98 163.9)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 4.08,
					height: 4.21,
					fill: "#fff",
					transform: "matrix(.077 .997 .997 -.071 179.9 159.53)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 4.08,
					height: 4.21,
					fill: "#fff",
					transform: "matrix(.077 .997 .997 -.071 183.79 155.15)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 4.08,
					height: 4.21,
					fill: "#fff",
					transform: "matrix(.077 .997 .997 -.071 187.67 150.78)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 4.08,
					height: 4.21,
					fill: "#fff",
					transform: "matrix(.077 .997 .997 -.071 191.57 146.4)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 4.08,
					height: 4.21,
					fill: "#fff",
					transform: "matrix(.077 .997 .997 -.071 195.46 142.03)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 4.08,
					height: 4.21,
					fill: "#fff",
					transform: "matrix(-.077 -.997 -.997 .071 218.8 115.83)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 4.08,
					height: 4.21,
					fill: "#fff",
					transform: "matrix(-.077 -.997 -.997 .071 214.9 120.2)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 4.08,
					height: 4.21,
					fill: "#fff",
					transform: "matrix(-.077 -.997 -.997 .071 211 124.55)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 4.08,
					height: 4.21,
					fill: "#fff",
					transform: "matrix(-.077 -.997 -.997 .071 207.1 128.92)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 4.08,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(85.9 30 175.8)scale(-1 1)skewY(.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 4.08,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(85.9 25.73 175.9)scale(-1 1)skewY(.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 4.08,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(-94.4 161.53 -17.37)skewX(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 4.08,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(-94.4 165.47 -21.59)skewX(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 4.08,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(-94.4 153.68 -9)skewX(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 4.08,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(-94.4 143.17 -34.38)skewX(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 4.08,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(-94.4 147.18 -34.59)skewX(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 4.08,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(-94.4 143.1 -38.38)skewX(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 4.08,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(-94.4 147.1 -38.58)skewX(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 4.08,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(-94.4 173.31 -29.96)skewX(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.16,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(-94.4 107.63 -49.55)skewX(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.16,
					height: 4.21,
					fill: "#fff",
					transform: "matrix(.077 .997 .997 -.071 166.85 74.32)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.16,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(-94.4 111.64 -49.76)skewX(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.16,
					height: 4.21,
					fill: "#fff",
					transform: "matrix(.077 .997 .997 -.071 170.74 69.94)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.16,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(-94.4 115.64 -49.95)skewX(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.16,
					height: 4.21,
					fill: "#fff",
					transform: "matrix(.077 .997 .997 -.071 174.61 65.58)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.16,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(265.9 119.81 -50.6)skewY(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.16,
					height: 4.21,
					fill: "#fff",
					transform: "matrix(.077 .997 .997 -.071 178.51 61.22)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.16,
					height: 4.21,
					fill: "#fff",
					transform: "matrix(.077 .997 .997 -.071 185.03 36.23)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.16,
					height: 4.21,
					fill: "#fff",
					transform: "matrix(.077 .997 .997 -.071 188.94 31.85)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.16,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(-94.4 107.1 -77.44)skewX(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.16,
					height: 4.21,
					fill: "#fff",
					transform: "matrix(.077 .997 .997 -.071 192.82 27.49)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.16,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(-94.4 111.1 -77.64)skewX(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.16,
					height: 4.21,
					fill: "#fff",
					transform: "matrix(.077 .997 .997 -.071 196.71 23.13)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.16,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(85.9 75.35 119.6)skewY(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.16,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(85.9 75.11 115.3)skewY(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.16,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(85.6 74.8 111.49)skewX(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.16,
					height: 4.21,
					fill: "#fff",
					transform: "matrix(-.077 -.997 -.997 .071 179.92 24.31)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.16,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(85.6 74.58 107.17)skewX(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.16,
					height: 4.21,
					fill: "#fff",
					transform: "matrix(-.077 -.997 -.997 .071 176.04 28.67)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.16,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(85.6 68.2 150.54)skewX(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.16,
					height: 4.21,
					fill: "#fff",
					transform: "matrix(-.077 -.997 -.997 .071 211.52 50.67)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.16,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(85.6 67.97 146.22)skewX(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.16,
					height: 4.21,
					fill: "#fff",
					transform: "matrix(-.077 -.997 -.997 .071 207.6 55.04)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.16,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(85.6 67.75 141.89)skewX(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.16,
					height: 4.21,
					fill: "#fff",
					transform: "matrix(-.077 -.997 -.997 .071 203.72 59.4)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.16,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(85.9 67.7 137.01)skewY(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.16,
					height: 4.21,
					fill: "#fff",
					transform: "matrix(-.077 -.997 -.997 .071 199.84 63.77)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 4.08,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(-94.4 105.52 -55.42)skewX(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 4.08,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(-94.4 109.52 -55.63)skewX(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 4.08,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(-94.4 113.53 -55.83)skewX(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 4.08,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(265.9 117.67 -56.5)skewY(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 4.08,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(265.9 121.68 -56.7)skewY(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 4.08,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(85.9 62.3 156.55)skewY(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 4.08,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(85.6 61.86 152.83)skewX(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 4.08,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(85.6 61.63 148.51)skewX(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 4.08,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(85.6 61.4 144.18)skewX(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 4.08,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(85.9 61.37 139.3)skewY(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 4.08,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(85.9 61.14 135)skewY(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 4.08,
					height: 4.21,
					fill: "#fff",
					transform: "matrix(.077 .997 .997 -.071 167.76 86.52)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 4.08,
					height: 4.21,
					fill: "#fff",
					transform: "matrix(.077 .997 .997 -.071 171.67 82.14)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 4.08,
					height: 4.21,
					fill: "#fff",
					transform: "matrix(.077 .997 .997 -.071 175.54 77.78)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 4.08,
					height: 4.21,
					fill: "#fff",
					transform: "matrix(.077 .997 .997 -.071 179.44 73.4)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 4.08,
					height: 4.21,
					fill: "#fff",
					transform: "matrix(.077 .997 .997 -.071 183.33 69.04)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 4.08,
					height: 4.21,
					fill: "#fff",
					transform: "matrix(.077 .997 .997 -.071 187.21 64.67)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 4.08,
					height: 4.21,
					fill: "#fff",
					transform: "matrix(-.077 -.997 -.997 .071 210.59 38.48)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 4.08,
					height: 4.21,
					fill: "#fff",
					transform: "matrix(-.077 -.997 -.997 .071 206.7 42.85)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 4.08,
					height: 4.21,
					fill: "#fff",
					transform: "matrix(-.077 -.997 -.997 .071 202.79 47.23)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 4.08,
					height: 4.21,
					fill: "#fff",
					transform: "matrix(-.077 -.997 -.997 .071 198.91 51.58)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 4.08,
					height: 4.21,
					fill: "#fff",
					transform: "matrix(-.077 -.997 -.997 .071 195.02 55.96)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 4.08,
					height: 4.21,
					fill: "#fff",
					transform: "matrix(-.077 -.997 -.997 .071 191.13 60.32)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 4.08,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(-94.4 121.6 -52.26)skewX(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 4.08,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(-94.4 125.53 -56.46)skewX(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 4.08,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(-94.4 113.75 -43.87)skewX(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 4.08,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(265.9 103.31 -69.7)skewY(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 4.08,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(-94.4 107.24 -69.47)skewX(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 4.08,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(265.9 103.22 -73.7)skewY(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 4.08,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(-94.4 107.16 -73.46)skewX(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 4.08,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(-94.4 133.37 -64.84)skewX(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.16,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(-94.4 186.32 21.26)skewX(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.16,
					height: 4.21,
					fill: "#fff",
					transform: "matrix(.077 .997 .997 -.071 180.96 229)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.16,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(265.9 190.84 20.6)skewY(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.16,
					height: 4.21,
					fill: "#fff",
					transform: "matrix(.077 .997 .997 -.071 184.85 224.64)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.16,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(-94.4 194.33 20.84)skewX(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.16,
					height: 4.21,
					fill: "#fff",
					transform: "matrix(.077 .997 .997 -.071 188.73 220.26)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.16,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(-94.4 198.33 20.63)skewX(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.16,
					height: 4.21,
					fill: "#fff",
					transform: "matrix(.077 .997 .997 -.071 192.63 215.9)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.16,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(265.9 178.2 -6.74)skewY(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.16,
					height: 4.21,
					fill: "#fff",
					transform: "matrix(.077 .997 .997 -.071 199.21 190.87)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.16,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(265.9 182.2 -6.96)skewY(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.16,
					height: 4.21,
					fill: "#fff",
					transform: "matrix(.077 .997 .997 -.071 203.1 186.49)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.16,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(-94.4 185.79 -6.68)skewX(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.16,
					height: 4.21,
					fill: "#fff",
					transform: "matrix(.077 .997 .997 -.071 206.98 182.13)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.16,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(-94.4 189.8 -6.88)skewX(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.16,
					height: 4.21,
					fill: "#fff",
					transform: "matrix(.077 .997 .997 -.071 210.9 177.76)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.16,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(85.6 -1.19 205.1)skewX(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.16,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(85.9 9.48 193.52)scale(-1 1)skewY(.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.16,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(85.9 -.9 200.21)skewY(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.16,
					height: 4.21,
					fill: "#fff",
					transform: "matrix(-.077 -.997 -.997 .071 197.94 174.6)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.16,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(85.9 -1.14 195.9)skewY(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.16,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(85.9 .9 193.71)scale(-1 1)skewY(.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.16,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(85.9 -1.36 191.6)skewY(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.16,
					height: 4.21,
					fill: "#fff",
					transform: "matrix(-.077 -.997 -.997 .071 190.2 183.33)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.16,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(85.6 -8.22 235.51)skewX(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.16,
					height: 4.21,
					fill: "#fff",
					transform: "matrix(-.077 -.997 -.997 .071 225.68 205.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.16,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(85.9 -7.8 230.56)skewY(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.16,
					height: 4.21,
					fill: "#fff",
					transform: "matrix(-.077 -.997 -.997 .071 221.77 209.69)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.16,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(85.6 -8.66 226.86)skewX(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.16,
					height: 4.21,
					fill: "#fff",
					transform: "matrix(-.077 -.997 -.997 .071 217.9 214.06)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.16,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(85.6 -8.88 222.54)skewX(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 8.16,
					height: 4.21,
					fill: "#fff",
					transform: "matrix(-.077 -.997 -.997 .071 214 218.42)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 4.08,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(-94.4 180.2 15.58)skewX(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 4.08,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(-94.4 184.2 15.39)skewX(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 4.08,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(-94.4 188.2 15.17)skewX(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 4.08,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(265.9 192.7 14.5)skewY(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 4.08,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(-94.4 196.2 14.75)skewX(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 4.08,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(-94.4 200.21 14.55)skewX(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 4.08,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(85.6 -14.35 242.12)skewX(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 4.08,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(85.6 -14.57 237.8)skewX(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 4.08,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(85.6 -14.79 233.47)skewX(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 4.08,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(85.6 -15.02 229.15)skewX(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 4.08,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(85.6 -15.25 224.82)skewX(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 4.08,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(85.6 -15.46 220.51)skewX(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 4.08,
					height: 4.21,
					fill: "#fff",
					transform: "matrix(.077 .997 .997 -.071 181.9 241.2)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 4.08,
					height: 4.21,
					fill: "#fff",
					transform: "matrix(.077 .997 .997 -.071 185.81 236.81)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 4.08,
					height: 4.21,
					fill: "#fff",
					transform: "matrix(.077 .997 .997 -.071 189.7 232.45)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 4.08,
					height: 4.21,
					fill: "#fff",
					transform: "matrix(.077 .997 .997 -.071 193.6 228.07)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 4.08,
					height: 4.21,
					fill: "#fff",
					transform: "matrix(.077 .997 .997 -.071 197.5 223.7)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 4.08,
					height: 4.21,
					fill: "#fff",
					transform: "matrix(.077 .997 .997 -.071 201.38 219.34)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 4.08,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(-94.4 201.8 -7.5)scale(1 -1)skewX(.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 4.08,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(85.9 4.36 217.38)scale(-1 1)skewY(.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 4.08,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(85.9 .07 217.47)scale(-1 1)skewY(.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 4.08,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(-94.4 202 4.49)scale(1 -1)skewX(.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 4.08,
					height: 4.21,
					fill: "#fff",
					transform: "matrix(-.077 -.997 -.997 .071 209.18 210.61)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 4.08,
					height: 4.21,
					fill: "#fff",
					transform: "matrix(-.077 -.997 -.997 .071 205.3 214.98)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 4.08,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(-94.4 200.29 18.52)skewX(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 4.08,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(-94.4 204.22 14.33)skewX(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 4.08,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(-94.4 192.44 26.91)skewX(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 4.08,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(-94.4 181.92 1.52)skewX(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 4.08,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(-94.4 185.93 1.3)skewX(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 4.08,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(-94.4 181.85 -2.46)skewX(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 4.08,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(265.9 186.3 -3.16)skewY(-.3)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					width: 4.08,
					height: 4.21,
					fill: "#fff",
					transform: "rotate(265.9 212.59 5.4)skewY(-.3)"
				})
			]
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff4e0",
			d: "M198.64 404.83c.2-4.66 5.82-26.58 8.6-36.96 4.3-.2 13.1-.83 14.08-1.73.97-.89 13.88 29.77 20.2 45.21l-42.12 2.84a33 33 0 0 1-.76-9.36"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#687488",
			d: "m205.98 396.98 23.39-1.32 8.58 95.82-22.16 2.13z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#2a4550",
			d: "m201.78 420.44 8.3-12.31 19.85-1.64 10.41 10.9 3.75-2.88c-3.83-4.16-11.78-12.64-13-13.2-1.53-.68-22.55 2.2-24.45 1.94-1.53-.21-7.06 10.17-9.64 15.38z"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 34.25,
			height: 26.49,
			x: 202.12,
			y: 407.35,
			fill: "#274253",
			rx: 13.24,
			transform: "rotate(-5.8 202.12 407.35)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#1d3138",
			d: "m203.98 419.11 6.45-11.79 14.58-1.7-13 4.81-7.94 13.13z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#2a4550",
			d: "m247.92 498.03-8.3 12.32-19.85 1.64-10.42-10.9-3.74 2.88c3.83 4.16 11.77 12.64 13 13.19 1.53.7 22.54-2.2 24.45-1.93 1.53.2 7.06-10.17 9.64-15.38z"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 34.25,
			height: 26.49,
			x: 247.57,
			y: 511.13,
			fill: "#274253",
			rx: 13.24,
			transform: "rotate(174.2 247.57 511.13)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#1d3138",
			d: "m245.72 499.36-6.45 11.8-14.58 1.69 13-4.8 7.94-13.13z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#687488",
			d: "M208.06 367.26c-1.6.38-2.33 19.98-2.08 29.72 7.43-.36 19.85-.3 23.4-1.32-1.02-3.55-5.05-20.08-8.34-29.31-3.66-.96-10.75.38-12.98.91"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#cdd1d7",
			d: "M198.77 669.34 56.36 326.2l-9.82 2.26 142.39 343.15z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#354661",
			d: "M60.87 328.37c-3.44-1.63-20.7-41.39-28.91-61.06-18.45-1.04-25.23 8.2-26.31 12.95 3.46 1.94 11.39 5.93 15.37 6.41 4.97.6-.76 14.55 4.51 12.67 5.28-1.88 14.39 26.99 16.2 28.72 1.44 1.39-1.92 4.65-3.78 6.1l3.01 8.44 12.67-4.51c10.55-3.76 14.1-3.84 16.88-6.02 2.8-2.19-5.35-1.66-9.64-3.7"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#cdd1d7",
			d: "M177.1 655 98.7 291.83l-10.07.47 78.4 363.15z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#354661",
			d: "M102.72 294.78c-3.09-2.22-12.93-44.43-17.46-65.26-17.97-4.34-26.3 3.53-28.21 8 3.06 2.54 10.14 7.89 13.97 9.08 4.78 1.49-3.37 14.17 2.16 13.27s9.3 29.13 10.77 31.16c1.17 1.63-2.72 4.23-4.81 5.33l1.44 8.85 13.27-2.17c11.06-1.8 14.56-1.24 17.7-2.89s-4.97-2.6-8.83-5.37"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#feb95e",
			d: "M293.17 558.63c5.96-20.96 30.6-44.3 42.16-53.36l12.66 4.88c4.57 9.17 3.35 48.44-4.2 68l-26.12-8.88z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "m330.33 509.54 5.43-4.83c4.63 0 13.51 1.09 12.07 5.43-1.45 4.35-12.27 1.41-17.5-.6"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#ec4949",
			stroke: "#ec4949",
			strokeWidth: 6.31,
			d: "m278.66 596.22 14.35-37.2c19.73 9.18 30.92 13.36 51.02 19.67l-14.35 37.2c-20.27-5.41-31.5-9.4-51.02-19.67Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#ec4949",
			d: "m337.16 499.37 3.55-9.2 14.2 5.47c-.93 3.17-2.73 8.2-3.55 9.2z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "m335.86 505.04 2.07-5.38 11.89 4.59-2.07 5.37z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "url(#paint0_linear_25837_69690)",
			d: "M216.13 557.67c14.32 36.12 10.9 72-33.34 89.54-36 14.28-65.06-8.72-79.39-44.84-14.32-36.11 5.47-89.82 26.33-98.09 23.1-9.16 72.08 17.28 86.4 53.4"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask1_25837_69690",
			width: 126,
			height: 150,
			x: 98,
			y: 502,
			maskUnits: "userSpaceOnUse",
			style: { maskType: "alpha" },
			children: /* @__PURE__ */ _jsx("path", {
				fill: "#18a0fb",
				d: "M216.13 557.67c14.32 36.12 10.9 72-33.34 89.54-36 14.28-65.06-8.72-79.39-44.83s5.47-89.83 26.33-98.1c23.1-9.16 72.08 17.28 86.4 53.4"
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			fill: "#18a0fb",
			mask: "url(#mask1_25837_69690)",
			children: [/* @__PURE__ */ _jsx("path", { d: "M122.37 602.33c-8.35-5.31-17.6-4.92-21.2-4.06l5.56 14c13.05-2.19 19.44 1.46 21 3.56.69-3.66 4.63-12.34 14.86-17.78 12.78-6.8 25.92 5.3 24.66 2.1s4.63-14.56 14.64-18.53c9.72-3.86 21.45.34 26.64 3.28-1.15-6.42 8.71-15.36 13.98-18.54l-5.55-14c-11.23 1.31-14.12 12.6-14.16 18.07-24.98-13.2-37.68 5.32-40.9 16.23-24.83-12.81-36.7 5.1-39.53 15.67" }), /* @__PURE__ */ _jsx("path", { d: "M132.47 626.27c-8.35-5.3-17.61-4.91-21.2-4.05l5.55 14c13.06-2.19 19.44 1.46 21 3.55.7-3.65 4.63-12.33 14.86-17.77 12.78-6.8 25.92 5.3 24.66 2.1s4.63-14.57 14.64-18.53c9.72-3.86 21.45.33 26.65 3.27-1.16-6.41 8.7-15.35 13.97-18.54l-5.55-14c-11.22 1.32-14.12 12.6-14.16 18.08-24.98-13.2-37.68 5.31-40.9 16.22-24.82-12.8-36.7 5.11-39.52 15.67" })]
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask2_25837_69690",
			width: 126,
			height: 150,
			x: 98,
			y: 502,
			maskUnits: "userSpaceOnUse",
			style: { maskType: "alpha" },
			children: /* @__PURE__ */ _jsx("path", {
				fill: "#fdc564",
				d: "M216.13 557.67c14.32 36.12 10.9 72-33.34 89.54-36 14.28-65.06-8.72-79.39-44.83s5.47-89.83 26.33-98.1c23.1-9.16 72.08 17.28 86.4 53.4"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask2_25837_69690)",
			children: /* @__PURE__ */ _jsx("path", {
				fill: "#000",
				fillOpacity: .07,
				d: "M208.27 638.75c5.57-7.41 25.96-16.53-1.68-4.23-31.86 14.18-71.48 8.47-110.06-53.93 17.63 95.48 83.61 79.2 111.74 58.15"
			})
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 8.36,
			cy: 19.01,
			fill: "#fff",
			fillOpacity: .3,
			rx: 8.36,
			ry: 19.01,
			transform: "rotate(-53.3 599.26 109)skewY(.1)"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 5.26,
			cy: 5.36,
			fill: "#fff",
			fillOpacity: .3,
			rx: 5.26,
			ry: 5.36,
			transform: "rotate(-53.4 640.8 86.16)skewY(.2)"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 314.67,
			cy: 662.54,
			fill: "#fff",
			rx: 140.74,
			ry: 70.79
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#56ba82",
			d: "m203.7 606.79 83.21-22.9 3.24 11.76a3.9 3.9 0 0 1-2.73 4.8l-75.69 20.82a3.9 3.9 0 0 1-4.8-2.73z"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 86.3,
			height: 15.6,
			x: 199.56,
			y: 591.75,
			fill: "#fdc564",
			transform: "rotate(-15.4 199.56 591.75)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fa4969",
			d: "M196.46 580.46a3.9 3.9 0 0 1 2.73-4.8l75.68-20.82a3.9 3.9 0 0 1 4.8 2.73l3.1 11.28-83.2 22.9z"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 314.66,
			cy: 662.54,
			fill: "#fff",
			rx: 140.74,
			ry: 70.79
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_25837_69690",
			x1: 129.73,
			x2: 185.92,
			y1: 504.28,
			y2: 645.97,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: .54,
				stopColor: "#01d4d5"
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#00b6b7"
			})]
		}) })
	]
});
export default SvgSki;
